export default function (state = '80', action) {
	switch (action.type) {
		case 'CHANGE_SIZE_BOT_ICON':
			return action.payload;
		default:
			return state;
	}
}